import { createAction } from 'redux-actions';

export const OPEN_LEAVE_SURVEY_MODAL = 'LEAVE_SURVEY_MODAL::OPEN';
export const CLOSE_LEAVE_SURVEY_MODAL = 'LEAVE_SURVEY_MODAL::CLOSE';
export const RESET_LEAVE_SURVEY_MODAL = 'LEAVE_SURVEY_MODAL::RESET';
export const DISABLE_LEAVE_SURVEY_MODAL = 'DISABLE_LEAVE_SURVEY_MODAL';

export const openLeaveSurveyModal = createAction(OPEN_LEAVE_SURVEY_MODAL);
export const closeLeaveSurveyModal = createAction(CLOSE_LEAVE_SURVEY_MODAL);
export const resetLeaveSurveyModal = createAction(RESET_LEAVE_SURVEY_MODAL);
export const disableLeaveSurveyModal = createAction(DISABLE_LEAVE_SURVEY_MODAL);
